window.$ = window.jQuery = require('jquery');
require('bootstrap/js/dist/popover');
require('X-editable/dist/bootstrap4-editable/js/bootstrap-editable');

$.fn.editableform.buttons =
  `<button type="submit" class="btn btn-primary btn-sm editable-submit">
    <i class="fa fa-fw fa-check"></i>
  </button>
  <button type="button" class="btn btn-default btn-sm editable-cancel">
    <i class="fa fa-fw fa-times"></i>
  </button>`;

$.fn.editable.defaults.ajaxOptions = { type: 'PATCH' };

$.fn.editable.defaults.emptytext = 'Κενό';

$.fn.editable.defaults.display = function (value) {
  let $element = $(this);

  switch($element.data('format')) {
  case 'currency':
    $element.text('€ ' + value);
    break;
  case 'percentage':
    $element.text(value + '%');
    break;
  default:
    $element.text(value);
  }
};

$.fn.editable.defaults.success = function () {
  if($(this).data('refresh')) {
    location.reload();
  }

  return null;
};

$(() => {
  $('.x-editable').editable({
    params: ({ name, value }) => {
      return { [name]: value };
    }
  });
});
